import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { HiOutlineChatAlt2 } from 'react-icons/hi';

function Section3CrossGroupAi({ visible, queryScopes, quickPrompts, onQuery }) {
  const [queryScope, setQueryScope] = useState('All Groups & Sub-Groups');
  const [quickPrompt, setQuickPrompt] = useState(quickPrompts[0] || '');
  const [question, setQuestion] = useState(quickPrompts[0] || '');
  const [response, setResponse] = useState(null);
  const [isRunning, setIsRunning] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (queryScopes.length && !queryScopes.includes(queryScope)) {
      setQueryScope(queryScopes[0]);
    }
  }, [queryScopes, queryScope]);

  const handlePromptChange = (value) => {
    setQuickPrompt(value);
    setQuestion(value);
  };

  const handleRun = async (e) => {
    e.preventDefault();
    const trimmed = question.trim();
    if (!trimmed || isRunning) return;

    setIsRunning(true);
    setResponse(null);
    setError('');
    try {
      const text = await onQuery({ scope: queryScope, userQuery: trimmed });
      setResponse(text);
    } catch (err) {
      setError(err.message || 'Cross-group query failed.');
    } finally {
      setIsRunning(false);
    }
  };

  if (!visible) return null;

  return (
    <section className="nlp-grouping-card">
      <h2 className="nlp-section-title nlp-section-title-icon">
        <HiOutlineChatAlt2 size={20} aria-hidden="true" />
        3. Interactive AI Intelligence Hub
      </h2>

      <form onSubmit={handleRun}>
        <div className="nlp-filter-grid nlp-filter-grid-2">
          <label className="nlp-filter-field">
            <span className="nlp-filter-label">Query Scope</span>
            <select value={queryScope} onChange={(e) => setQueryScope(e.target.value)}>
              {queryScopes.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>

          <label className="nlp-filter-field">
            <span className="nlp-filter-label">Quick Analysis Prompts</span>
            <select value={quickPrompt} onChange={(e) => handlePromptChange(e.target.value)}>
              {quickPrompts.map((opt) => (
                <option key={opt} value={opt}>{opt}</option>
              ))}
            </select>
          </label>
        </div>

        <label className="nlp-filter-field nlp-filter-field-full">
          <span className="nlp-filter-label">Your Question to AI Analyst</span>
          <textarea
            className="nlp-question-input"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
            rows={3}
          />
        </label>

        <button type="submit" className="nlp-primary-btn" disabled={isRunning || !question.trim()}>
          {isRunning ? 'Analyzing…' : 'Run Query'}
        </button>
      </form>

      {error && (
        <div className="nlp-grouping-error nlp-grouping-error-inline" role="alert">
          {error}
        </div>
      )}

      {response && (
        <div className="nlp-ai-response nlp-markdown" role="status">
          <ReactMarkdown>{response}</ReactMarkdown>
        </div>
      )}
    </section>
  );
}

export default Section3CrossGroupAi;
